import { Component, inject, OnInit } from '@angular/core';
import { AppInformationService, BrewersUnitOfWork, SessionInformationService } from 'app/core/core.module';
import { InvoiceService } from 'app/core/invoice.service';
import { ProductCategory } from 'app/core/model/product-category';
import { DxiColumnComponent } from 'devextreme-angular/ui/nested';
import { Column } from 'devextreme/ui/data_grid';
import moment from 'moment';

@Component({
    standalone: false,
    selector: 'app-sales-summary-report',
    templateUrl: './sales-summary-report.component.html',
    styleUrl: './sales-summary-report.component.scss',
})
export class SalesSummaryReportComponent implements OnInit {
    invoiceService = inject(InvoiceService);
    sessionInfo = inject(SessionInformationService);
    appInfo = inject(AppInformationService);
    uow = inject(BrewersUnitOfWork);

    filter: { startDate?: Date; endDate?: Date; month?: number; year?: number };
    categories: ProductCategory[];
    categorySummaries: any[];
    productSummaries: any[];
    dailyCategorySummaries: any[];
    dailyCategorySummaryColumns: Column[] = [];
    months = [
        { name: 'Jan', value: 0 },
        { name: 'Feb', value: 1 },
        { name: 'Mar', value: 2 },
        { name: 'Apr', value: 3 },
        { name: 'May', value: 4 },
        { name: 'Jun', value: 5 },
        { name: 'Jul', value: 6 },
        { name: 'Aug', value: 7 },
        { name: 'Sep', value: 8 },
        { name: 'Oct', value: 9 },
        { name: 'Nov', value: 10 },
        { name: 'Dec', value: 11 },
    ];
    years: number[] = [];

    async ngOnInit() {
        let year = 2024;
        while (year <= moment(new Date()).get('year')) this.years.push(year++);
        this.categories = await this.uow.productCategories.whereActive('displayOrder, name');
        this.dailyCategorySummaryColumns.push({ dataField: 'day' });
        this.categories.forEach((category) => {
            this.dailyCategorySummaryColumns.push({
                dataField: category.name,
                format: { type: 'currency', precision: 2 },
            });
        });

        const filter = this.sessionInfo.getItem('sales-summary-filter');
        if (!filter) this.clear();
        else this.filter = filter;
        await this.getDailyCategorySummaries();
    }

    async search() {
        if (!this.filter) return;

        this.appInfo.pleaseWaitShow();
        this.categorySummaries = await this.invoiceService.getCategorySummaries(this.filter);
        this.productSummaries = await this.invoiceService.getProductSummaries(this.filter);
        this.sessionInfo.setItem('sales-summary-filter', this.filter);
        this.appInfo.pleaseWaitHide();
    }

    async getDailyCategorySummaries() {
        if (!this.filter) return;

        // month is zero base, year and days are not
        const date = new Date(this.filter.year, this.filter.month, 1);
        const dailyTotals = await this.invoiceService.getDailyCategoryTotals(date);
        const daysInMonth = moment(date).daysInMonth();
        const summaries = [];
        for (let day = 1; day < daysInMonth + 1; day++) {
            const summary = { day };
            this.categories.forEach((category) => {
                const name = category.name;
                summary[name] = null;

                const dailyTotal = dailyTotals.find((s) => moment(s.invoiceDate).get('date') === day && s.categoryId === category.id);
                if (!dailyTotal) return;
                summary[name] = dailyTotal.total;
            });
            summaries.push(summary);
        }
        this.dailyCategorySummaries = summaries;
        this.sessionInfo.setItem('sales-summary-filter', this.filter);
    }

    clear() {
        this.filter = {
            startDate: moment(new Date()).add(-30, 'days').toDate(),
            endDate: new Date(),
            month: moment(new Date()).get('month'),
            year: moment(new Date()).get('year'),
        };
        this.sessionInfo.removeItem('sales-summary-filter');
    }
}
